import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiShield } = FiIcons;

const Footer = () => {
  const references = [
    'World Bank: Generator costs in developing countries (fuel cost ~£0.30 per kWh, full cost ~£0.40+ per kWh)',
    'WHO: Health facilities without reliable electricity access',
    'World Bank/UN: Electricity access gap framing and economic impact studies'
  ];

  return (
    <footer className="bg-gray-900 text-white py-16 px-4">
      <div className="max-w-4xl mx-auto">
        {/* References */}
        <div className="mb-12">
          <h3 className="text-lg font-semibold mb-6">References & Context</h3>
          <div className="space-y-3">
            {references.map((reference, index) => (
              <p key={index} className="text-sm text-gray-300 leading-relaxed">
                • {reference}
              </p>
            ))}
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex items-start gap-3">
            <SafeIcon 
              icon={FiShield} 
              className="text-xl text-gray-400 mt-0.5 flex-shrink-0" 
              aria-hidden="true"
            />
            <div>
              <h4 className="font-semibold text-gray-200 mb-2">Important Disclaimer</h4>
              <p className="text-sm text-gray-300 leading-relaxed">
                Educational tool only. Not investment advice, and not an offer or solicitation. 
                Results are estimates based on your inputs and may differ from real-world costs. 
                This calculator is provided for informational purposes and should not be relied 
                upon as the sole basis for financial decisions.
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 pt-6 mt-8 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Tribes Capital. Built for educational purposes.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;